import { Grid, IconButton, InputBase, Paper, Box, Avatar } from "@mui/material";
import NavigationIcon from '@mui/icons-material/Navigation';
import React, { useState } from "react";
import { StyledComment } from "./comment.style";
import HlxButton from '../../commonComponents/button/button';
import UptimeGeneralDialog from '../../dialogComponents/generalDialog/generalDialog';
import { stringAvatar } from "utils/functions";
export interface ICommentProps {
  submitComment: () => void;
  onKeyPress: (e: any) => void;
  handleChange: (e: any) => void;
  canComment: boolean;
  value: string;
  avatar: string;
  locale: {
    placeholderInput: string
  };
  warningConfig: {
    name: string,
    key: string,
    enabled: boolean,
    editWarning: {
      title: string,
      content:string,
      labelButton: string
    }
  };
  localeWarningDialog: {
    warning: string,
    msgITARFedRamp: string,
    ok: string,
  };
  currentUser: any;
}

const Comment = (props: ICommentProps) => {
  const [onSubmitComment, setOnSubmitComment] = useState(false);
  const [eventKeyPress, setEventKeyPress] = useState();
  const [onKeyPressComment, setOnKeyPressComment] = useState(false);
  const [isOpenWarning, setIsOpenWarning] = useState(false);

  const showWarning = props.warningConfig?.enabled && JSON.parse(localStorage.getItem(props.warningConfig?.key) || 'true');

  const confirmWarningDialog = (
    <>
      <HlxButton
        label={props.localeWarningDialog?.ok || props.warningConfig?.editWarning?.labelButton}
        onClick={() => {
          if(!!onSubmitComment) {
            props.submitComment();
            setOnSubmitComment(false);
          } else if (!!onKeyPressComment) {
            props.onKeyPress(eventKeyPress);
            props.submitComment();
            setOnKeyPressComment(false);
          }
          setIsOpenWarning(false);
          localStorage.setItem(props.warningConfig?.key, 'false');
          }
        }
      />
    </>
  );
  return (
    <>
      <StyledComment>
        <Box className='comments-wrap'>
          <Grid container direction="row" alignItems="center">
            <Grid item>
              <Box className="avatar-input" pr={2}>
                {!!props.avatar ?
                  <Avatar
                    sx={{width: 40, height: 40}}
                    src={props.avatar}
                    alt="user avatar"
                    slotProps={{
                      img: {
                        id: "img-comment-avatar",
                        title: props.currentUser?.avatar_name,
                      }
                    }}
                  />
                  :
                  <Avatar 
                    {...stringAvatar(props.currentUser?.avatar_name, 40)}
                    slotProps={{
                      img:{
                        id: "img-comment-avatar",
                        title: props.currentUser?.avatar_name
                      }
                    }}
                  />
                }
              </Box>
            </Grid>
            <Grid item xs>
              <Paper component="form" className="cmt-form">
                <InputBase
                  className="inputBase"
                  multiline
                  placeholder={props.locale?.placeholderInput}
                  inputProps={{ "aria-label": props.locale?.placeholderInput }}
                  value={props.value}
                  onKeyPress={(e: any) => {
                    if(!showWarning) {
                      props.onKeyPress(e)
                    } else if (e.key === 'Enter' && !!props.value && showWarning && !isOpenWarning) {
                      setIsOpenWarning(true);
                      setOnKeyPressComment(true);
                      setEventKeyPress(e);
                    } else if (e.key === 'Enter' && !props.value) {
                      e.preventDefault();
                    }
                   }}
                  onChange={(event) => props.handleChange(event)}
                  disabled={!props.canComment}
                  required={true}
                  id="txt-comment-inputbase"
                />
                <IconButton
                  className={`submit-btn ${
                    !!props.value ? "submit-active-btn" : ""
                  }`}
                  type="button"
                  aria-label="search"
                  disabled={!props.canComment}
                  onClick={() => {
                    if(!showWarning){
                      props.submitComment();
                    }
                    else if(!!props.value && showWarning && !isOpenWarning){
                      setIsOpenWarning(true);
                    }
                    setOnSubmitComment(true)
                  }}
                  id="btn-comment-submit"
                >
                  <NavigationIcon />
                </IconButton>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </StyledComment>
      <UptimeGeneralDialog
        title={props.warningConfig?.editWarning?.title || props.localeWarningDialog?.warning}
        content={props.warningConfig?.editWarning?.content || props.localeWarningDialog?.msgITARFedRamp}
        isOpen={isOpenWarning}
        buttonSubmit={confirmWarningDialog}
        deviders={false}
        headerBackgroundDefault={false}
        hideButtonCancel={true}
        hideCloseIcon={true}
        commonStyles={{ width: '480px' }}
        handleClose={()=>{}}
        headerDefault={true}
        disableBackdropClick={false}
      />
    </>
  );
}

export default Comment;
